import React from "react";
import { classNames } from "@/utils";

interface Props {
    className?: string;
}
const Badge: React.FC<React.PropsWithChildren<Props>> = ({ children, className }) => {

    return (
        <span className={
            classNames(
                'absolute -top-1 -right-1 transform',
                'px-2 py-1',
                'inline-flex items-center justify-center',
                'text-xs font-bold text-white leading-none',
                'bg-red-600 rounded-full',
                className
            )
        }>
            {children}
        </span>
    )
}

export default Badge;
